/* eslint class-methods-use-this: "off"  */

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import classnames from "classnames";
import _ from "underscore";
import { smallCaps } from "@exo/style-mixins";
import vars, { solidButton, outlineButton } from "@exo/narrative-tracker-variables";
import Icon from '@mdi/react';
import { 
	mdiCheck as acceptIcon,
	mdiClose as rejectIcon,
} from '@mdi/js';

const TermsText = styled.div`
	${vars.mainfont};
	font-size: 14px;
	line-height: 1.2em;
	color: ${props => props.darkUI ? vars.sky_1 : vars.text_2}
`;
const ButtonContainer = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: nowrap;
	justify-content: center;
	gap 40px;
	margin-top: 40px;
`;
const ControlButton = styled.div`
	${smallCaps(vars.mainfontBold)};
	cursor: "pointer";
	height: 40px;
	flex-grow: 0;
	flex-shrink: 0;
	font-size: 12px;
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	justify-content: center;
	gap: 8px;
`;
const OutlineButton = styled(ControlButton)`
	${(props) => outlineButton(
		props.darkUI ? vars.cerulean_2 : vars.cerulean_2, 
		props.darkUI ? vars.cerulean_1 : vars.cerulean_1, 
		props.darkUI ? vars.cerulean_2 : vars.cerulean_2, 
		props.darkUI ? vars.cerulean_1 : vars.cerulean_1, 
		props.darkUI ? vars.grey_3 : vars.grey_0_2, 
		props.darkUI ? vars.grey_2_7 : vars.grey_0_1, 
		1
	)};
	padding: 10px 12px 10px 10px;
	width: fit-content;
`;
const SolidButton = styled(ControlButton)`
	${(props) => solidButton(
		props.darkUI ? vars.cerulean_2 : vars.cerulean_2, 
		props.darkUI ? vars.cerulean_1 : vars.cerulean_1, 
		props.darkUI ? vars.charcoal_1 : "#fff", 
		props.darkUI ? vars.charcoal_1 : "#fff", 
		false
	)};
	padding: 10px 12px 10px 10px;
	width: fit-content;
`;
const ButtonText = styled.span`
	${vars.mainfontBold};
	font-size: 15px;
	font-weight: 500;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	margin-bottom: 1px;
	transition: none;
	z-index: 1;
`;
const ButtonIcon = styled(Icon)`
	flex-shrink: 0;
	z-index: 1;
`;
const SolidButtonIcon = styled(ButtonIcon)`
	color: ${props => props.darkUI ? vars.charcoal_1 : "fff"};
`;
const OutlineButtonIcon = styled(ButtonIcon)`
	color: ${props => props.darkUI ? vars.cerulean_2 : vars.cerulean_2};
`;

const BUTTON_ICON_SIZE = "20px";

const TermsAndConditions = (props) =>  {

	const buttonBoxClass = classnames("login__submit-box", { spinner: props.validationInProgress });
	const logoClass = classnames("appHeader__logo");

	return (
		<div className="login">
			<div className="login__box">

				<div
					id="appHeader__logo"
					className={logoClass}
				>
					<div className="appHeader__logo--mark" />
					{/* <div className="appHeader__logo--text" /> */}
				</div>

				<h1 className="login__header">Terms and Conditions</h1>

				<TermsText darkUI={props.darkUI}>
					<p>Welcome to exoINSIGHT, a powerful data analytics platform exclusively owned by Exovera LLC.</p>
					<br />
					<p>Before you start exploring our world of data-driven wonders, please be aware that your access to and use of exoINSIGHT is subject to the terms and conditions of the subscription or access agreement between Exovera and your organization.</p>
					<br />
					<p>By accepting below, you confirm that you are authorized to access and use exoINSIGHT in accordance with such terms and conditions.</p>
				</TermsText>

				<ButtonContainer>
					<OutlineButton 
						type="submit" 
						darkUI={props.darkUI} 
						onClick={props.rejectTermsAndConditions}
					>
						<OutlineButtonIcon path={rejectIcon} size={BUTTON_ICON_SIZE} />
						<ButtonText>Decline</ButtonText>
					</OutlineButton>
					<SolidButton 
						type="submit" 
						darkUI={props.darkUI} 
						onClick={props.acceptTermsAndConditions}
					>
						<SolidButtonIcon path={acceptIcon} size={BUTTON_ICON_SIZE} />
						<ButtonText>Accept</ButtonText>
					</SolidButton>
				</ButtonContainer>

			</div>
		</div>
	);
}

TermsAndConditions.propTypes = {
	darkUI: PropTypes.bool.isRequired,
	dispatch: PropTypes.func.isRequired,
	acceptTermsAndConditions: PropTypes.func.isRequired,
	rejectTermsAndConditions: PropTypes.func.isRequired,
};

export default TermsAndConditions;
